var styles = {
  "Divider": "Polaris-Divider"
};

export { styles as default };
